import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { isDarkMode } from '../../../../../utils/helpers';
import { getButtonTheme, getTextColor } from '../../../../../style';
import breakpoints from 'theme/material/breakpoints';

export const DeactivateAccountContainer = styled('div')(() => ({
  margin: '0',
  padding: '20px 0',
  borderTop: `1px dashed ${isDarkMode() ? '#848484' : '#dae1e9'}`,
  maxWidth: 365,
  [breakpoints.down(834.05)]: {
    maxWidth: '100%',
  },
  [breakpoints.down(639.05)]: {
    maxWidth: 365,
  },
}));

export const DeactivateAccountTitle = styled('h3')(() => ({
  color: getButtonTheme().sideBarHeader,
  fontSize: 18,
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: '23px',
  letterSpacing: '-0.5px',
  marginTop: 0,
  marginBottom: 20,
}));

export const DeactivateAccountContent = styled('div')(() => ({
  color: getTextColor().LIGHT_GRAY.color,
  fontSize: 15,
  fontStyle: 'normal',
  fontWeight: 'normal',
  lineHeight: '20px',
  letterSpacing: '-0.3px',
  marginBottom: 20,
  '> p': {
    margin: 0,
    fontWeight: 'normal',
  },
  '> ul': {
    listStyle: 'initial',
    listStyleType: 'disc',
    paddingLeft: 20,
    marginTop: 10,
  },
  '> ul > li': {
    fontSize: 15,
    border: 'none !important',
    padding: '0.5rem 0',
    margin: 0,
    display: 'list-item',
    fontWeight: 700,
  },
  '> ul > li:hover': {
    border: 'none !important',
    cursor: 'initial',
  },
}));

export const DeactivateAccountContentLink = styled('a')(() => ({
  textDecoration: 'underline !important',
  color: `${isDarkMode() ? '#05C4C1' : '#2B8FD7'} !important`,
  '&:hover': {
    textDecoration: 'none !important',
  },
}));

const ButtonLink = styled(Link)({
  display: 'flex',
  padding: '12px 22px',
  justifyVontent: 'center',
  alignItems: 'center',
  gap: '6px',
  alignSelf: 'stretch',
  borderRadius: '6px',
  fontSize: 14,
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: '16px',
  justifyContent: 'center',
});

export const DeactivateAccountButton = styled(ButtonLink)(() => ({
  border: `1px solid ${getButtonTheme().primaryRed.border} !important`,
  background: getButtonTheme().primaryRed.background + ' !important',
  color: `${getButtonTheme().primaryRed.text} !important`,
  '&:hover': {
    background: getButtonTheme().primaryRed.hover.background,
    borderColor: getButtonTheme().primaryRed.hover.border,
  },
  '&:active': {
    background: getButtonTheme().primaryRed.active.background,
    borderColor: getButtonTheme().primaryRed.active.border,
    color: `${getButtonTheme().primaryRed.active.text} !important`,
  },
}));

export const DeleteAccountButton = styled(ButtonLink)(() => ({
  border: `1px solid #E21D4A`,
  background: isDarkMode() ? 'transparent' : '#FFF',
  color: `#E21D4A !important`,
  padding: '12px 22px',
  gap: '1px',
  borderRadius: '4px',
  '> span': {
    color: `#E21D4A !important`,
    fontSize: 14,
  },
  '&:hover': {
    background: `${getButtonTheme().secondaryRed.hover.background} !important`,
    color: `${getButtonTheme().secondaryRed.hover.text} !important`,
    borderColor: getButtonTheme().secondaryRed.hover.border,
    '> span': {
      color: `${getButtonTheme().secondaryRed.hover.text} !important`,
    },
  },
  '&:active': {
    background: getButtonTheme().secondaryRed.active.background,
    borderColor: getButtonTheme().secondaryRed.active.border,
    color: `${getButtonTheme().secondaryRed.active.text} !important`,
  },
  '&:active > span': {
    color: `${getButtonTheme().secondaryRed.active.text} !important`,
  },
}));

export const ButtonLinkIconStyle = {
  width: 14,
  height: 14,
};
